import { QUEUE_STATUS, REVIEW_STATUS } from '../constants/lms-course-review.constants';

export const SEARCH_MODE = {
  COURSE: 'course',
  PROGRAM: 'program',
};

export const PROGRAM_COURSE_STATUS = {
  PENDING: 'PENDING',
  LINKED: 'LINKED',
  NOT_ON_CANVAS: 'NOT_ON_CANVAS',
};

export const PROGRAM_COURSE_FILTER = {
  ALL: 'ALL',
  PENDING: 'PENDING',
  LINKED: 'LINKED',
  NOT_ON_CANVAS: 'NOT_ON_CANVAS',
};

export const PROGRAM_COURSE_FILTER_OPTIONS = [
  { key: PROGRAM_COURSE_FILTER.ALL, label: 'All' },
  { key: PROGRAM_COURSE_FILTER.PENDING, label: 'Pending' },
  { key: PROGRAM_COURSE_FILTER.LINKED, label: 'Linked' },
  { key: PROGRAM_COURSE_FILTER.NOT_ON_CANVAS, label: 'Not on Canvas' },
];

/**
 * Map API program search row to UI model.
 */
export const toProgramSearchItem = (row) => ({
  resourceId: row.resourceId,
  resourceName: row.resourceName,
  coverage: {
    total: row.coverage?.total ?? 0,
    pending: row.coverage?.pending ?? 0,
    linked: row.coverage?.linked ?? 0,
    notOnCanvas: row.coverage?.notOnCanvas ?? 0,
  },
});

/**
 * Build the Resolve/bulk-link target for a PENDING program child.
 * Always targets the D2L program course (resourceId), which is how PENDING
 * rows are associated on the API (catalog suggested_resources → child).
 */
const toPendingSuggestion = (row) => ({
  id: row.resourceId,
  resourceKey: row.resourceId,
  name: row.resourceName,
  score: row.suggestion?.score ?? null,
  description:
    row.suggestion?.score != null
      ? `Match score: ${(row.suggestion.score * 100).toFixed(0)}%`
      : undefined,
});

/**
 * Map API program course row to UI model.
 */
export const toProgramCourseItem = (row) => ({
  resourceId: row.resourceId,
  resourceName: row.resourceName,
  status: row.status,
  canvasCourseTitle: row.canvasCourseTitle ?? null,
  canvasExternalId: row.canvasExternalId ?? null,
  linkedResourceId: row.linkedResourceId ?? null,
  linkedResourceName: row.linkedResourceName ?? null,
  programs: Array.isArray(row.programs) ? row.programs : [],
  catalogId: row.catalogId ?? null,
  suggestion: row.status === PROGRAM_COURSE_STATUS.PENDING ? toPendingSuggestion(row) : null,
});

/**
 * Map a program course PENDING row into the queue item shape used by ResolutionDialog.
 */
export const toQueueItemFromProgramCourse = (course) => ({
  id: course.catalogId,
  canvasCourseName: course.canvasCourseTitle || course.resourceName,
  canvasCourseId: course.canvasExternalId || '—',
  queuedAt: undefined,
  reviewStatus: REVIEW_STATUS.PENDING.key,
  status: QUEUE_STATUS.PENDING,
  suggestedResource: course.suggestion,
});

/**
 * Build bulk-resolve queue items from selected program pending courses.
 * Shape matches `toBulkResolveBody` / `bulkResolveQueueItems`.
 */
export const toProgramBulkResolveItems = (courses) =>
  courses
    .filter((course) => course.status === PROGRAM_COURSE_STATUS.PENDING && course.catalogId != null)
    .map((course) => ({
      id: course.catalogId,
      suggestedResource: {
        resourceKey: course.suggestion?.resourceKey ?? course.resourceId,
      },
    }));
